import BaseService from './BaseService';

export default class CompanyService {
  baseService: BaseService;
  ApiBaseService: BaseService;
  
  constructor(orderType: string) {
      this.baseService = new BaseService(orderType);
      this.ApiBaseService = new BaseService('');
    }

  async info (): Promise<any> {
    try {
      const response = await this.ApiBaseService.http.get('company/info');
      return response.data.company;
    } catch (error: any) {
      console.error('Erro CompanyService:', error);
      throw error;
    }
  }
}